import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { THEMES } from 'root-constants'
import { PageIdWoofzPt1 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_PT1: Record<
  Exclude<PageIdWoofzPt1, PageIdWoofzPt1.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.DOG_SEX_PT1]: {
    id: PageId.DOG_SEX_PT1,
    hasHeader: true,
    headerId: HeaderId.TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.DOG_AGE_PT1]: {
    id: PageId.DOG_AGE_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.SHELTER_PT1]: {
    id: PageId.SHELTER_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.DOG_BREED_PT1]: {
    id: PageId.DOG_BREED_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_PT1]: {
    id: PageId.URGE_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_MENU,
  },
  [PageId.STARTED_PT1]: {
    id: PageId.STARTED_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.PLACE_PT1]: {
    id: PageId.PLACE_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.GOALS_PT1]: {
    id: PageId.GOALS_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.ACCIDENTS_PT1]: {
    id: PageId.ACCIDENTS_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.CONCERNS_PT1]: {
    id: PageId.CONCERNS_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_2_PT1]: {
    id: PageId.URGE_2_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_MENU,
  },
  [PageId.LIVING_SITUATION_PT1]: {
    id: PageId.LIVING_SITUATION_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.POTTY_BREAKS_PT1]: {
    id: PageId.POTTY_BREAKS_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.CRATE_TRAINING_PT1]: {
    id: PageId.CRATE_TRAINING_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.BEHAVIOR_PT1]: {
    id: PageId.BEHAVIOR_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.COMMANDS_PT1]: {
    id: PageId.COMMANDS_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.TRAINING_TIME_PT1]: {
    id: PageId.TRAINING_TIME_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
  },
  [PageId.PREPARE_FLOW_PT1]: {
    id: PageId.PREPARE_FLOW_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.COMMITMENT_SCREEN_PT1]: {
    id: PageId.COMMITMENT_SCREEN_PT1,
  },
  [PageId.EMAIL_PT1]: {
    id: PageId.EMAIL_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.NEWSLETTER_URGE_PT1]: {
    id: PageId.NEWSLETTER_URGE_PT1,
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageId.SUBSCRIPTIONS_PT1]: {
    id: PageId.SUBSCRIPTIONS_PT1,
  },
  [PageId.CANCEL_OFFER_PT1]: {
    id: PageId.CANCEL_OFFER_PT1,
  },
  [PageId.CHAT_UPSELL_PT1]: {
    id: PageId.CHAT_UPSELL_PT1,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_PT1]: {
    id: PageId.UPSELL_PT1,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_FEEDING_GUIDE_PT1]: {
    id: PageId.UPSELL_FEEDING_GUIDE_PT1,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_EMOTIONAL_SUPPORT_PT1]: {
    id: PageId.UPSELL_EMOTIONAL_SUPPORT_PT1,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_PT1]: {
    id: PageId.DOWNLOAD_PT1,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
